module.exports = __webpack_public_path__ + "img/vehicle-blue.fcd30047.png";